/**
 * SECONDARY-DETACH.MODAL
 * Before deleting an answer of the primary question that triggers secondary questions :
 * detach them (they are asked to everyone) or delete them too
 */
import { useState } from "react"
import { withTranslation, WithTranslation } from "react-i18next"
import Modal from "@/components/modal"
import RadioOption from "@/components/radio-option"

interface OwnProps {
  answer: string //Label of the answer to delete
  dependents: string[] //Labels of the secondary questions triggered by this answer
  onClose: Function
  onValidate: Function //(mode : "detach" | "delete")
}

type Props = WithTranslation & OwnProps

function SecondaryDetachModal(props: Props) {
  const { t } = props
  const [mode, setMode] = useState<"detach" | "delete">("detach")

  const options: { id: "detach" | "delete"; title: string; hint: string }[] = [
    { id: "detach", title: t("secondary_detach_detach"), hint: t("secondary_detach_detach_hint") },
    { id: "delete", title: t("secondary_detach_delete"), hint: t("secondary_detach_delete_hint") }
  ]

  return (
    <Modal
      isCloseButtonVisible
      title={t("secondary_detach_title")}
      onClose={props.onClose}
      onNext={() => props.onValidate(mode)}
      onNextCta={t("secondary_detach_cta")}>
      <div className="grey-t text-sm">{t("secondary_detach_text", { answer: props.answer })}</div>

      <div className="red-t mt-3 rounded-lg px-3 py-2 text-sm" style={{ backgroundColor: "#eb5a4650" }}>
        {props.dependents.map((name, i) => (
          <div key={i}>
            <b>{"▸ " + name}</b>
          </div>
        ))}
      </div>

      {options.map((option) => (
        <RadioOption
          key={option.id}
          isSelected={mode === option.id}
          onClick={() => setMode(option.id)}
          title={option.title}
          hint={option.hint}
        />
      ))}
    </Modal>
  )
}

export default withTranslation()(SecondaryDetachModal)
